<template>
  <div class="FileUploadInput">
    <div v-if="hasPendingFile && !uploadError">
      <div v-if="!binary">
        <img :src="pendingFileDataUrlRepresentation" alt />
      </div>
      <div class="field">
        <div class="control">
          <button
            class="button is-info"
            :class="loading ? 'is-loading' : ''"
            :disabled="loading"
            @click="send"
          ></button>
        </div>
      </div>
    </div>
    <div class="error" v-if="uploadError">
      <article class="message is-danger is-small">
        <div class="message-body">
          <p>{{ error }}</p>
          <br />
          <div class="button is-danger" @click="reset()">Réésayer</div>
        </div>
      </article>
    </div>
    <div class="file" v-if="!hasPendingFile && !uploadError">
      <label class="file-label" style="width:100%; text-align: center;">
        <input
          class="file-input"
          type="file"
          name="resume"
          @change="handleFile"
        />
        <span
          class="file-cta"
          style="font-size: 11px; display: inline-block;width:100%;"
        >
          <span class="file-label">
            <span>{{ label }}</span>
            <span class="has-text-info text-small">{{ sublabel }}</span>
          </span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/pictures";

export default {
  name: "FileUploadInput",
  props: {
    error: {
      type: String,
      required: false,
      default: "Une erreur est survenue"
    },
    label: {
      type: String,
      required: false,
      default: ".png, noir sur transparent"
    },
    sublabel: {
      type: String,
      required: false,
      default: "600px * 600px"
    },
    binary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasPendingFile: false,
      pendingFile: null,
      pendingFileDataUrlRepresentation: "",
      loading: false,
      uploadError: false
    };
  },
  methods: {
    handleFile(e) {
      let files = e.target.files;
      if (!Array.isArray(files)) {
        files = Array.from(files);
      }
      if (typeof files[0] !== "undefined") {
        this.pendingFile = files[0];
        this.hasPendingFile = true;
        this.send();
      } else {
        this.pendingFile = null;
        this.hasPendingFile = false;
      }
    },
    reset() {
      this.uploadError = false;
      this.hasPendingFile = false;
    },
    sendFile(file) {
      if (this.binary) {
        return this.$store.dispatch(t.SEND_BINARY, file);
      } else {
        return this.$store.dispatch(t.SEND_PICTURE, file);
      }
    },
    send() {
      this.loading = true;
      this.sendFile(this.pendingFile)
        .then(res => {
          this.loading = false;
          this.pendingFile = null;
          this.hasPendingFile = false;
          this.$emit("file", res);
        })
        .catch(e => {
          this.loading = false;
          this.uploadError = true;
          throw e;
        });
    }
  },
  watch: {
    hasPendingFile(val) {
      if (!val) return;
      if (this.binary) return;
      const r = new FileReader();
      r.onload = e => {
        if (e && e.target && e.target.result) {
          this.pendingFileDataUrlRepresentation = e.target.result;
        }
      };
      r.readAsDataURL(this.pendingFile);
    }
  }
};
</script>

<style lang="scss">
.FileUploadInput {
  .file-label {
    flex-direction: column;
  }
  .file-cta {
    padding: 1em;
    height: auto;
  }
}
</style>
